import { Box, Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import StaffList from "../components/operation/staff/StaffList";
import StaffDetails from "../components/operation/staff/StaffDetails";
import { useDispatch } from "react-redux";
import { getAllSubUserAction } from "../../store/reducers/subUserSlice";

const ClientOperationStaff = () => {
  const [selectedId, setSelectedId] = useState<any | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllSubUserAction({ status: "ACTIVE" }));
  }, []);

  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 12 }}
        sx={{ background: "#f4f4f4", paddingTop: "16px", height: "100vh" }}
      >
        <Grid
          item
          xs={12}
          md={4}
          sx={{ paddingLeft: "0px !important", paddingTop: "0px !important" }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            <StaffList setSelectedId={setSelectedId} selectedId={selectedId} />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          sx={{ paddingLeft: "16px !important", paddingTop: "0px !important" }}
        >
          <Container
            maxWidth="lg"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              background: "#fff",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  border: "1px solid #C4CDD5",
                }}
              >
                <PageInfoTitle
                  title="Staff Details"
                  // button={selectedId ? "Edit" : ""}
                  // onClick={() => handleEditVehicle(selectedId)}
                />
              </Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  //   border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  overflow: "hidden",
                  // padding: "10px",
                  padding: "10px 10px !important",
                }}
              >
                {selectedId ? (
                  <StaffDetails
                    selectedId={selectedId}
                    // onEditClick={() => console.log("Edit clicked")}
                  />
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#4A4A4A",
                      fontWeight: 500,
                    }}
                  >
                    Please select a staff member to see details
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientOperationStaff;
